import {SchedulingWhats} from "../../models/SchedulingWhats";
import {WrapperFactory} from "../WrapperFactory";

let schedulingWhatsApi = {
    async get(token,company_id,params={}){
        let response = await window.axios.get('/api/schedulingWhats', {
            params:{
                api_token:token,
                company_id:company_id,
                ...params
            }
        });

        let wrapper = WrapperFactory.fromResponse(response.data)
        wrapper.transform(e=>new SchedulingWhats(e));
        return wrapper
    },
    async update(schedulingWhats, token, companyId){
        let response = await window.axios.put('/api/schedulingWhats/'+schedulingWhats.id, schedulingWhats, {
            params:{
                api_token:token,
                company_logged:companyId
            }
        });

        return new SchedulingWhats(response.data);
    },
}

export default schedulingWhatsApi